module.exports = __webpack_public_path__ + "static/media/colliers89.b1ab4016.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/colliers89.png
// module id = 709
// module chunks = 12